var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPunchList = function SvgPunchList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#10A2FC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.97 35.26H8.74V5.5H16v.98H9.7v27.8H29V6.49h-6.14V5.5h7.12v29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.64 38H8.06A2.07 2.07 0 0 1 6 35.94V4.83c0-1.15.93-2.06 2.06-2.06h9.74v.97H8.06c-.6 0-1.08.5-1.08 1.09v31.1c0 .6.49 1.08 1.08 1.08h22.58c.6 0 1.09-.49 1.09-1.08V4.83c0-.6-.5-1.09-1.09-1.09h-9.16v-.97h9.16c1.15 0 2.06.92 2.06 2.06v31.1c0 1.14-.92 2.06-2.06 2.06V38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 9.21h-5.08V1.4h5.08v7.8Zm-4.1-.97h3.12V2.37h-3.13v5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.85 8.24H16v.97h6.84v-.97ZM19.91 0h-.97v1.89h.97V0Zm-5.95 14.6-1.51-1.52.68-.69.83.83 1.54-1.52.68.69-2.22 2.2Zm11.95-2.11h-8.49v.97h8.5v-.97Zm-11.95 5.97-1.51-1.53.68-.69.83.83 1.54-1.52.68.69-2.22 2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 14.6-1.51-1.52.68-.69.83.83 1.54-1.52.68.69-2.22 2.2Zm0 3.86-1.51-1.53.68-.69.83.83 1.54-1.52.68.69-2.22 2.22Zm11.95-2.12h-8.49v.97h8.5v-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 18.46-1.51-1.53.68-.69.83.83 1.54-1.52.68.69-2.22 2.22Zm11.95-2.12h-8.49v.97h8.5v-.97Zm-11.95 6.22-1.51-1.52.68-.69.83.82 1.54-1.52.68.7-2.22 2.21Zm11.95-2.12h-8.49v.98h8.5v-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 22.56-1.51-1.52.68-.69.83.82 1.54-1.52.68.7-2.22 2.21Zm0 3.85-1.51-1.51.68-.7.83.83 1.54-1.52.68.68-2.22 2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 26.41-1.51-1.51.68-.7.83.83 1.54-1.52.68.68-2.22 2.22Zm11.95-2.11h-8.49v.98h8.5v-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.96 26.41-1.51-1.51.68-.7.83.83 1.54-1.52.68.68-2.22 2.22Zm11.95-2.11h-8.49v.98h8.5v-.98Zm-11.95 6.22L12.45 29l.68-.7.83.84 1.54-1.53.68.69-2.22 2.22Zm11.95-2.12h-8.49v.98h8.5v-.98Z"
  }))));
};
export default SvgPunchList;